import './PatientDetails.css'
import { useLocation, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import DashHeader from '../../../Component/sections/DashHeader/DashHeader'
import Table from '../../../Component/custom/Table/Table'
import { useState , useEffect } from 'react'
import Modal from '../../../Component/custom/Modal/Modal.jsx'
import { Exit } from '../../../Assets/SVGS'
import Icon from '../../../Component/common/Icon/Icon'
import getData from '../../../utils/getData'
function PatientDetails(route){
  const { t } = useTranslation();
  const {patientName} = useParams()
  const [selectedImage , setSelectedImage] = useState(null)
  const [showModal , setShowModal] = useState(false)
  const location = useLocation()
  const patientDetails = location.state
  const [loader , setLoader] = useState(false)
  const [medicalVisits , setMedicalVisits] = useState([])

  // get data
  const getMedicalVisits = async()=>{
    setLoader(true)
    try{
      const res = await getData(`medical-history/user/${patientDetails.id}`)
      setMedicalVisits(res.data.data)
    }
    finally{
      setLoader(false)
    }
  } 
  const handleSelectedImage = (img)=>{
    setSelectedImage(img)
    setShowModal(true)
  }

  useEffect(()=>{
    getMedicalVisits()
  } , [])
  
  return (
    <div className='patientDetails-container'>
      <div className='patientDetails-content'>
        <DashHeader header={t('patientDetails')}></DashHeader>
        <div className='details'>
          <h3>{patientName}</h3>
          <div>
            <p>{t('ageLabel')} {patientDetails.age}</p>
            <p>{t('genderLabel')} {patientDetails.gender}</p>
            <p>{t('phoneLabel')} {patientDetails.phone}</p>
          </div>
        </div>
        <Table
          loader={loader}
          data={medicalVisits}
          headers={[t('date'), t('diagnosis'), t('notesLabel'), t('attachments')]}
          keys={["date", "diagnosis", "notes"]}
          renderAction={(item) => (
            <td className='attachments'>
              {medicalVisits?.map((item) => (
                  item.attachments.map((i)=>(
                    <img
                      onClick={() => handleSelectedImage(item.url)}
                      src={item.path}
                      alt='img'
                    />
                    )
                  )
                
              ))}
            </td>
          )}
        />

        <Modal isOpen={showModal}>

          <div className='icon' onClick={() => setShowModal(false)}>
            <Icon icon={<Exit width='30px' />} />
          </div>

          <div className='images'>
            <div className='image'>
              <img src={selectedImage} alt='attachment' />
              <a href={selectedImage} download>
                <button>{t('download')}</button>
              </a>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}
export default PatientDetails